import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import GeneralDayDetailDayDetail from 'lumen/components/general/day-detail/day-detail';
import type HotelRevenueInsightDetailController from 'lumen/controllers/hotel/revenue-insight/detail';

interface HotelRevenueInsightDetailSignature {
  Args: {
    controller: HotelRevenueInsightDetailController;
    model: unknown;
  };
}

<template>
  <GeneralDayDetailDayDetail
    @activeCompset={{@controller.hotelAndMarketService.activeCompset}}
    @changeDay={{@controller.changeDay}}
    @currency={{@controller.riSelections.riCurrency}}
    @currentHotel={{@controller.hotel}}
    {{! @glint-expect-error: Incorrect type }}
    @date={{@controller.date}}
    {{! @glint-expect-error: Incorrect type }}
    @isRedirected={{true}}
    @model={{@controller.model}}
    @offset={{@controller.offset}}
    @otaId={{@controller.otaId}}
    @paceTabFilterMessage={{t "revenue_insight.nr_of_rooms_total"}}
    @ratesEvolutionDisabled={{@controller.ratesEvolutionDisabled}}
    @ratesParams={{@controller.ratesParams}}
    @redirect={{@controller.redirect}}
    @selectedOTA={{@controller.selectedOTA}}
    @type={{@controller.type}}
    @updateOffset={{@controller.updateOffset}}
    @updateType={{@controller.updateType}}
  />
</template> satisfies TOC<HotelRevenueInsightDetailSignature>;
